<template>
  <div>
    <div class="d-flex mt-5 mb-5">
      <v-col cols="3" class="d-flex flex-column">
        <span class="helvetica-medium mr-3 fs-18 d-inline-block mt-1"
          >Адрес:</span
        >
      </v-col>
      <div class="d-flex flex-columns">
        <div class="helvetica-medium fs-18 d-inline-block mt-2">
          {{ info.indication[0].address }}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <v-col cols="12">
        <div class="fs-18 d-inline-block mt-2">
          Показания приборов учета необходимо передавать
          <div class="tes-card__title" @click="lawPush = true">
            до {{ info.recommendedPeriod.finishDate }} числа каждого месяца
          </div>
        </div>
      </v-col>
    </div>
    <div v-if="windowSize.x < 768">
      <div
        class="mt-5 d-flex grey--text"
        v-for="item in info.indication"
        :key="`${item.meterNumber}${item.serviceName}`"
      >
        <span class="helvetica-medium fs-18 d-inline-block shrink black--text"
          >{{ item.serviceName }}
          <span v-if="item.zone" class="sub-item">{{ item.zone }}</span></span
        >
        <v-row class="justify-space-between">
          <v-text-field
            class="ml-2"
            type="number"
            filled
            outlined
            hide-details
            v-model="item.value"
            :disabled="currentDay > 25 || item.status === 'false'"
            placeholder="0.00"
            @change="saveCurrentIndication($event, item)"
          />
          <p class="ml-3 mt-2 fs-18">
            {{ !item.lastIndication ? "пусто" : item.lastIndication }}
          </p>
        </v-row>
        <v-row class="justify-space-between fs-13 helvetica-medium">
          <span class="ml-2">№ {{ item.meterNumber }}</span>
          <span v-if="item.lastIndication"
            >{{ `${item.date == 0 ? "" : "от"}` }} {{ format(item.date) }}</span
          >
        </v-row>
      </div>
    </div>
    <v-data-table
      v-else
      class="mt-5 d-flex flex-column"
      :headers="headers"
      :items="info.indication"
    >
      <template v-slot:item.name="{ item }">
        <p>{{ item.serviceName }}</p>
        <span v-if="item.zone" class="sub-item">{{ item.zone }}</span>
      </template>
      <template v-slot:item.value="{ item }">
        <v-text-field
          class="mt-5"
          type="number"
          :label="
            item.status === 'false' ? 'Срок поверки истек' : 'Введите показания'
          "
          :disabled="currentDay > 25 || item.status === 'false'"
          v-model="item.value"
          @change="saveCurrentIndication($event, item)"
          solo
        ></v-text-field>
      </template>
      <template v-slot:item.lastIndication="{ item }">
        <div v-if="item.lastIndication" class="ml-2">
          {{ `${item.date == 0 ? "" : "от"}` }} {{ format(item.date) }}
          <p class="green--text">
            {{ !item.lastIndication ? "пусто" : item.lastIndication }}
          </p>
        </div>
        <div v-else class="ml-2">
          {{ "пусто" }}
        </div>
      </template>
    </v-data-table>
    <v-btn
      class="green-button white--text mt-6"
      depressed
      @click="setIndicationsWithoutRegistartion(info.indication)"
      :disabled="
        !info.indication.filter((item) => item.value).length || currentDay > 25
      "
      >Сохранить</v-btn
    >

    <v-dialog v-model="lawPush" class="d-flex">
      <v-card>
        <v-card-title class="headline"
          >ПП РФ от 06.05.2011г. № 354</v-card-title
        >
        <v-card-text>
          «В соответствии с действующим законодательством (ПП РФ от 06.05.2011г.
          № 354) потребитель вправе при наличии индивидуальных приборов учёта
          коммунальных услуг ежемесячно снимать их показания и передавать
          исполнителю коммунальной услуги или уполномоченному им лицу не позднее
          25-го числа текущего месяца. Показания, поступившие после указанной
          даты, при расчете размера платы за коммунальные услуги не учитываются.
          В таком случае начисление платы осуществляется исходя из
          среднемесячного объема потребления коммунального ресурса либо исходя
          из норматива потребления коммунальной услуги»
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="lawPush = false"
            >Ясно</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="finalPush"
      :max-width="windowSize.x < 768 ? '90%' : '40%'"
      content-class="pa-0 ma-0"
    >
      <v-card>
        <v-card-title class="headline green--text justify-center"
          >Ваши показания успешно сохранены!</v-card-title
        >
        <v-card-actions class="d-flex justify-center">
          <a class="button-link" href="https://tatenergosbyt.ru">
            <v-btn color="green" class="white--text mb-5 ml-8 d-flex"
              >Перейти на главную страницу</v-btn
            >
          </a>
          <v-btn
            color="green"
            class="white--text mb-5 ml-8 d-flex"
            @click="$router.push('/guest-payments')"
            >Произвести оплату</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal-check-meter
      v-if="checkMeter"
      v-model="checkMeter"
      :date="statusMeter"
    ></modal-check-meter>
  </div>
</template>

<script>
import moment from "moment";
import ModalCheckMeter from "../../components/modals/ModalCheckMeter.vue";

export default {
  name: "ReadingChild",
  data: () => ({
    currentDay: new Date().getDate(),
    lawPush: false,
    finalPush: false,
    dateWarning: false,
    checkMeter: false,
    statusMeter: "",
    masCheckWindowFirst: [],
    windowSize: {
      x: 0,
      y: 0,
    },
    headers: [
      {
        text: "Категория",
        value: "name",
      },
      { text: "Прибор учета", value: "meterNumber" },
      { text: "Текущие показания", value: "value" },
      { text: "Предыдущие показания", value: "lastIndication" },
    ],
  }),
  props: ["personalAccount", "info"],
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    if (this.currentDay > 25) {
      this.dateWarning = true;
    }
  },
  components: {
    ModalCheckMeter,
  },
  methods: {
    format(date) {
      return date == 0 ? "" : moment(date).format("DD.MM.YYYY");
    },
    saveCurrentIndication(item, current) {
      if (current.status != null) {
        if (!this.masCheckWindowFirst.includes(current.meterNumber)) {
          this.statusMeter = current.status;
          this.checkMeter = true;
        }

        this.masCheckWindowFirst.push(current.meterNumber);
      }

      let lastInd = +current.lastIndication.replace(/,/g, ".");

      current.consumption = isNaN(lastInd)
        ? Number(item)
        : Number(item) - lastInd;

      if (lastInd > item) {
        this.$store.commit("common/ADD_ALERT", {
          text: "Введите правильное значение",
          type: "error",
        });
        current.value = "";
      }
    },
    checkIndication(val) {},
    setIndicationsWithoutRegistartion(payload) {
      let indications = payload.filter((item) => item.value);
      this.$store
        .dispatch("guest/setIndicationsWithoutRegistartion", {
          domHoz: this.personalAccount,
          indications,
        })
        .then(() => {
          this.finalPush = true;
        })
        .catch((error) => {
          this.$store.dispatch("guest/showAlert", {
            text: error.message,
            type: "error",
          });
        });
    },
    onResize() {
      this.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .d-flex {
    display: flex;
    width: 70vw;
    flex-flow: wrap;
  }
  .v-card__text,
  .v-card__title {
    word-break: normal;
  }
}
.v-text-field {
  width: 210px;
}
.button-link {
  text-decoration: none;
}
.sub-item {
  opacity: 0.5;
}
</style>
